import { useState } from "react";
import { api } from "../lib/api";
import { toast } from "sonner";
import { useI18n } from "../lib/i18n";

export default function NewsletterForm({ context = "footer", onSuccess }) {
  const { t } = useI18n();
  const [email, setEmail] = useState("");
  const [loading, setLoading] = useState(false);

  const submit = async (e) => {
    e.preventDefault();
    if (!email) return;
    setLoading(true);
    try {
      await api.post("/newsletter/subscribe", { email, genres: [], tier: "free" });
      toast.success(t("toast.subscribed"));
      setEmail("");
      onSuccess?.();
    } catch (err) {
      toast.error(t("toast.subscribeFail"));
    } finally {
      setLoading(false);
    }
  };

  return (
    <form
      onSubmit={submit}
      className="flex items-stretch gap-0 w-full max-w-md"
      data-testid={`newsletter-form-${context}`}
    >
      <input
        type="email"
        value={email}
        onChange={(e) => setEmail(e.target.value)}
        placeholder={t("newsletter.form.email")}
        required
        className="flex-1 bg-background border border-border px-3 py-2.5 text-sm placeholder:text-muted-foreground focus:outline-none focus:border-foreground"
        data-testid={`newsletter-email-${context}`}
      />
      <button
        type="submit"
        disabled={loading}
        className="bg-foreground text-background px-5 text-sm border border-foreground hover:bg-[hsl(var(--accent))] hover:border-[hsl(var(--accent))] transition-colors disabled:opacity-50"
        data-testid={`newsletter-submit-${context}`}
      >
        {loading ? t("newsletter.form.submitting") : t("newsletter.form.submit")}
      </button>
    </form>
  );
}
